<div class="modal-centered" style="width:100%;">
  <div class="modal-content">
    <div class="modal-header border-bottom">
      <h5 class="modal-title fw-semibold mb-0">LinkedIn — {{ selectedWorkshop?.name }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="close()" [disabled]="isWorking"></button>
    </div>
    <div class="modal-body px-4 py-4">
      <div *ngIf="hasCv()" class="mb-4">
        <label class="form-label text-dark mb-3" style="font-size: 14px; font-weight: 500;">Candidate Submission</label>
        <div class="d-flex align-items-center justify-content-between border rounded p-4 bg-light">
          <div class="d-flex align-items-center">
            <i class="fe fe-file-text me-3 text-primary" style="font-size: 28px;"></i>
            <div>
              <span style="font-size: 14px; font-weight: 500; display: block;">LinkedIn Input File</span>
              <span class="text-muted" style="font-size: 12px;">{{ selectedWorkshop?.email }}</span>
            </div>
          </div>
          <div class="d-flex gap-2">
            <button class="btn btn-sm btn-outline-primary" (click)="viewCv()" [disabled]="isWorking">
              <i class="fe fe-eye me-1"></i> View
            </button>
            <button class="btn btn-sm btn-outline-primary" (click)="downloadCv()" [disabled]="isWorking">
              <i class="fe fe-download me-1"></i> Download
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="!hasCv()" class="mb-4">
        <label class="form-label text-dark mb-3" style="font-size: 14px; font-weight: 500;">Candidate Submission</label>
        <div class="text-center py-5 border rounded bg-light">
          <i class="fe fe-alert-circle text-muted mb-3" style="font-size: 32px; display: block;"></i>
          <p class="text-muted mb-0" style="font-size: 14px;">Submission not available</p>
        </div>
      </div>

      <div *ngIf="hasUpdatedCv()" class="mb-4">
        <label class="form-label text-dark mb-3" style="font-size: 14px; font-weight: 500;">Processed LinkedIn Guide</label>
        <div class="d-flex align-items-center justify-content-between border rounded p-4 bg-light">
          <div class="d-flex align-items-center">
            <i class="fe fe-file-text me-3 text-success" style="font-size: 28px;"></i>
            <div>
              <span style="font-size: 14px; font-weight: 500; display: block;">Moderator Processed Guide</span>
              <span class="text-muted" style="font-size: 12px;">{{ selectedWorkshop?.email }}</span>
            </div>
          </div>
          <div class="d-flex gap-2">
            <button class="btn btn-sm btn-outline-success" (click)="viewUpdatedCv()" [disabled]="isWorking">
              <i class="fe fe-eye me-1"></i> View
            </button>
            <button class="btn btn-sm btn-outline-success" (click)="downloadUpdatedCv()" [disabled]="isWorking">
              <i class="fe fe-download me-1"></i> Download
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="canMarkDone()" class="alert alert-info border-0 py-2 mb-0 mt-3" style="font-size: 13px;">
        Mark LinkedIn as done when work is finished — no file upload required.
      </div>
    </div>
    <div class="modal-footer border-top bg-light" *ngIf="!isCompleted() || isLegacyReviewed()">
      <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="isWorking">Close</button>
      <button type="button" class="btn btn-primary" *hasPermission="'workshops.manage'"
        (click)="proceedWithWorkshop()"
        [disabled]="isWorking">
        <span *ngIf="isWorking" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        {{ proceedButtonLabel() }}
      </button>
    </div>
  </div>
</div>
